import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import TeamRouter from './TeamRouter.js';
import Firebase, { FirebaseContext } from './Firebase';
import 'bootstrap/dist/css/bootstrap.css';
import ReactGA from 'react-ga4';

ReactGA.initialize('G-XXXXXXXXXX');

const root = createRoot(document.getElementById('root'));
root.render(
  <FirebaseContext.Provider value={new Firebase()}>
    <TeamRouter />
  </FirebaseContext.Provider>
);
